import {
    Injectable,
    Signal,
    WritableSignal,
    computed,
    effect,
    signal
} from '@angular/core';
import { Control } from '@dat/iq-controls';

import { Component, Dashboard, Section } from '../../models';
import { DashboardController } from './iq-builder-dashboard.controller';
// console.log(this._dashboards());
@Injectable({
    providedIn: 'root',
})
export class IqBuilderStateStatusService {
   
    private _dashboards: WritableSignal<Record<string, DashboardController>> =
        signal({});

    
    constructor() {
        effect(() => {
            // Keep this around for debugging purposes
            // const controllers = this._dashboards();
            // if (!controllers) return;
            // const built = Object.keys(controllers).reduce(
            //     (acc, key) => ({
            //         ...acc,
            //         [key]: controllers[key]?.build?.(),
            //     }),
            //     {},
            // );
            // console.log(built);
        });
    }

    getDashboardData(id: string): Signal<Dashboard> {
        return computed(() => {
            return this._dashboards()?.[id]?.build();
        });
    }

    getDashboardCache(dashboardId: string): Signal<any> {
        return computed(() => {
            return this._dashboards()?.[dashboardId]?.getCache()?.build();
        });
    }

    getSectionCache(dashboardId: string, sectionId: string): Signal<any> {
        return computed(() => {
            return this._dashboards()
                ?.[dashboardId]?.getSection(sectionId)
                ?.getCache()
                ?.build();
        });
    }

    updateProps(
        dashboardId: string,
        sectionId: string,
        componentId: string,
        props: any,
    ) {
        this._dashboards.set({
            ...this._dashboards(),
            [dashboardId]: this._dashboards()?.[
                dashboardId
            ].updateComponentProps(sectionId, componentId, props),
        });
    }
    updateComponent(
        dashboardId: string,
        sectionId: string,
        componentId: string,
        updateData: Partial<Component>,
    ) {
        this._dashboards.set({
            ...this._dashboards(),
            [dashboardId]: this._dashboards()?.[dashboardId]?.updateComponent(
                sectionId,
                componentId,
                updateData,
            ),
        });
    }

    updateControlProps(
        dashboardId: string,
        sectionId: string,
        componentId: string,
        controlId: string,
        controlData: Partial<Control>,
    ) {
        this._dashboards.set({
            ...this._dashboards(),
            [dashboardId]: this._dashboards()?.[
                dashboardId
            ]?.updateControlProps(
                sectionId,
                componentId,
                controlId,
                controlData,
            ),
        });
    }

    getSectionData(id: string, dashboardId: string): Signal<Section> {
        return computed((): Section => {
            return this._dashboards()?.[dashboardId].getSection(id).build();
        });
    }

    getComponentData(
        id: string,
        sectionId: string,
        dashboardId: string,
    ): Signal<Component> {
        return computed(() => {
            return this._dashboards()
                ?.[dashboardId].getSection(id)
                .getComponent(sectionId)
                .build();
        });
    }

    updateDashboardCache(id: string, data: any) {
        this._dashboards.set({
            ...this._dashboards(),
            [id]: this._dashboards()?.[id].updateCache(data),
        });
    }

    appendDashboardData(dashboardId: string, key: string, data: any) {
        this._dashboards.set({
            ...this._dashboards(),
            [dashboardId]: this._dashboards()?.[
                dashboardId
            ].appendDashboardData(dashboardId, key, data),
        });
    }

    
    appendDashboardCache(
        dashboardId: string,
        key: string,
        data: any,
        dataType: 'array' | 'object' = 'array',
    ) {
      console.warn('appendDashboardCache is deprecated. ');
    }

    addDashboard(dashboard: Dashboard): Signal<Dashboard> {
        this._dashboards.set({
            ...this._dashboards(),
            [dashboard.id]: new DashboardController({
                ...dashboard,
                loaded: true,
            }),
        });

        return computed(() => {
            const currentDashboard = this._dashboards()?.[dashboard.id];

            return currentDashboard?.build();
        });
    }

    /**
     * Replaces an existing component with a new component.
     * You can keep specific keys from the existing component by passing an array of keys to keep.
     *
     * @param dashboardId - The id of the dashboard
     * @param sectionId - The id of the section
     * @param componentId - The id of the component
     * @param component - The component to replace the existing component with
     * @param opts.keep - An array of keys to keep from the existing component
     */
    replaceComponent(
        dashboardId: string,
        sectionId: string,
        componentId: string,
        component: Component,
        opts: {
            keep?: string[];
        },
    ) {
        this._dashboards.set({
            ...this._dashboards(),
            [dashboardId]: this._dashboards()?.[dashboardId].replaceComponent(
                sectionId,
                componentId,
                component,
                opts,
            ),
        });
    }

    updateSection(
        dashboardId: string,
        sectionId: string,
        updateData: Partial<Section>,
    ) {
        this._dashboards.set({
            ...this._dashboards(),
            [dashboardId]: this._dashboards()?.[dashboardId].updateSection(
                sectionId,
                updateData,
            ),
        });
    }

    

    updateControlByControlId(controlId: string, control: any): void {
        const currentDashboards: Record<string, DashboardController> = {
            ...this._dashboards(),
        };

        const newDashboards: Record<string, DashboardController> = Object.keys(
            currentDashboards,
        ).reduce(
            (acc: Record<string, DashboardController>, dashboardId: string) => {
                return {
                    ...acc,
                    [dashboardId]: currentDashboards[
                        dashboardId
                    ].updateControlByControlId(controlId, control),
                };
            },
            {},
        );
        this._dashboards.set(newDashboards);
    }
}
